import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { getUsers, getJobs, getApplications, getContacts } from '../services/api';

const statCards = (users, jobs, apps, contacts) => [
  { label: 'Total Users',        value: users,    icon: 'fa-users',     color: '#0066FF', bg: '#e8f0ff', to: '/users' },
  { label: 'Total Jobs',         value: jobs,     icon: 'fa-briefcase', color: '#00C896', bg: '#e6fff6', to: '/jobs' },
  { label: 'Applications',       value: apps,     icon: 'fa-file-alt',  color: '#f59e0b', bg: '#fff8e6', to: '/applications' },
  { label: 'Enquiries',          value: contacts, icon: 'fa-envelope',  color: '#8b5cf6', bg: '#f3eeff', to: '/contacts' },
];

export default function Dashboard() {
  const [data, setData]       = useState({ users: [], jobs: [], apps: [], contacts: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.allSettled([getUsers(), getJobs(), getApplications(), getContacts()])
      .then(([u, j, a, c]) => {
        setData({
          users:    u.status === 'fulfilled' ? (u.value.users    || u.value || []) : [],
          jobs:     j.status === 'fulfilled' ? (j.value.jobs     || [])            : [],
          apps:     a.status === 'fulfilled' ? (a.value.applications || a.value || []) : [],
          contacts: c.status === 'fulfilled' ? (c.value || [])                     : [],
        });
        setLoading(false);
      });
  }, []);

  const unread   = data.contacts.filter(c => !c.isRead).length;
  const pending  = data.apps.filter(a => a.status === 'pending').length;
  const activeJobs = data.jobs.filter(j => j.isActive).length;

  return (
    <Layout>
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ fontWeight: 800, color: '#0A1628', margin: '0 0 4px' }}>Dashboard</h2>
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Welcome back! Here's what's happening today.</p>
      </div>

      {/* Stat Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 20, marginBottom: 32 }}>
        {statCards(data.users.length, data.jobs.length, data.apps.length, data.contacts.length).map((s, i) => (
          <Link to={s.to} key={i} style={{ textDecoration: 'none', background: '#fff', borderRadius: 16, padding: '24px 20px', border: '1.5px solid #eef0f8', boxShadow: '0 4px 16px rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', gap: 16, transition: 'all .2s' }}>
            <div style={{ width: 52, height: 52, borderRadius: 14, background: s.bg, color: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>
              <i className={`fa ${s.icon}`}></i>
            </div>
            <div>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#0A1628', lineHeight: 1 }}>
                {loading ? '...' : s.value}
              </div>
              <div style={{ fontSize: 13, color: '#888', marginTop: 4 }}>{s.label}</div>
            </div>
          </Link>
        ))}
      </div>

      {/* Alert Badges */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20, marginBottom: 32 }}>
        {[
          { label: 'Pending Applications', value: pending,    color: '#f59e0b', bg: '#fff8e6', icon: 'fa-clock',        to: '/applications' },
          { label: 'Unread Enquiries',      value: unread,     color: '#ef4444', bg: '#fff0f0', icon: 'fa-bell',         to: '/contacts' },
          { label: 'Active Jobs',           value: activeJobs, color: '#00C896', bg: '#e6fff6', icon: 'fa-check-circle', to: '/jobs' },
        ].map((a, i) => (
          <Link to={a.to} key={i} style={{ textDecoration: 'none', background: a.bg, borderRadius: 14, padding: '18px 20px', display: 'flex', alignItems: 'center', gap: 14, border: `1.5px solid ${a.color}30` }}>
            <i className={`fa ${a.icon}`} style={{ fontSize: 22, color: a.color }}></i>
            <div>
              <div style={{ fontSize: 22, fontWeight: 800, color: a.color }}>{loading ? '...' : a.value}</div>
              <div style={{ fontSize: 12, color: a.color, fontWeight: 600 }}>{a.label}</div>
            </div>
          </Link>
        ))}
      </div>

      {/* Recent Tables */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {/* Recent Jobs */}
        <div style={{ background: '#fff', borderRadius: 16, border: '1.5px solid #eef0f8', overflow: 'hidden' }}>
          <div style={{ padding: '18px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h6 style={{ fontWeight: 700, color: '#0A1628', margin: 0 }}>Recent Jobs</h6>
            <Link to="/jobs" style={{ fontSize: 12, color: '#0066FF', fontWeight: 600, textDecoration: 'none' }}>View All</Link>
          </div>
          <div style={{ padding: '8px 0' }}>
            {loading ? <p style={{ padding: '16px 20px', color: '#aaa', fontSize: 13 }}>Loading...</p> :
              data.jobs.slice(0, 5).map((job, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 20px', borderBottom: i < 4 ? '1px solid #f9f9f9' : 'none' }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#0A1628' }}>{job.title}</div>
                    <div style={{ fontSize: 11, color: '#aaa' }}>{job.company}</div>
                  </div>
                  <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 50, background: job.isActive ? '#e6fff6' : '#f5f5f5', color: job.isActive ? '#00C896' : '#aaa' }}>
                    {job.isActive ? 'Active' : 'Inactive'}
                  </span>
                </div>
              ))
            }
          </div>
        </div>

        {/* Recent Enquiries */}
        <div style={{ background: '#fff', borderRadius: 16, border: '1.5px solid #eef0f8', overflow: 'hidden' }}>
          <div style={{ padding: '18px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h6 style={{ fontWeight: 700, color: '#0A1628', margin: 0 }}>Recent Enquiries</h6>
            <Link to="/contacts" style={{ fontSize: 12, color: '#0066FF', fontWeight: 600, textDecoration: 'none' }}>View All</Link>
          </div>
          <div style={{ padding: '8px 0' }}>
            {loading ? <p style={{ padding: '16px 20px', color: '#aaa', fontSize: 13 }}>Loading...</p> :
              data.contacts.slice(0, 5).map((c, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 20px', borderBottom: i < 4 ? '1px solid #f9f9f9' : 'none' }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#0A1628' }}>{c.name}</div>
                    <div style={{ fontSize: 11, color: '#aaa' }}>{c.subject}</div>
                  </div>
                  <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 50, background: c.isRead ? '#f5f5f5' : '#fff0f0', color: c.isRead ? '#aaa' : '#ef4444' }}>
                    {c.isRead ? 'Read' : 'New'}
                  </span>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </Layout>
  );
}
